import React from "react";
import { BookOpen } from "lucide-react";

// THE RETURN PATH FROM WRITING (consolidated loop): TWS sends the student to write in their essay -> they write -> READ MY CHANGES
// -> TWS reads the essay as it stands now, reappraises, and the controller selects the next developmental need. The control means
// "this bout of editing is over — read the current essay and respond to it", never "my essay is finished". The student never has to
// come back to the chat and type "done". The backend recognises EXACTLY this event string (developmental_studio_turn.DONE_WRITING_EVENT).
export const DONE_WRITING_EVENT = "the student says they have done writing in their essay";

export const DoneWriting = ({ disabled = false, runCoach }) => (
  <button type="button" data-testid="tws-done-writing" disabled={disabled}
    onClick={() => runCoach("", DONE_WRITING_EVENT)}
    title="Finished this bout of editing? The Writing Studio reads your essay as it stands now and responds to it. It does not mean your essay is finished."
    className="inline-flex items-center gap-1.5 rounded-full bg-[#8C3A2A] text-white text-[12px] font-medium px-3.5 py-1.5 hover:bg-[#6B2C20] disabled:opacity-40 transition-colors">
    <BookOpen className="h-3.5 w-3.5" /> Read my changes
  </button>
);
